module.exports = __webpack_public_path__ + "media/site_templates/www.rubbishremoval.company/images/about_us-db63948c918f7087b3157ae4683aa745.jpg";